import { addIntegration, replayIntegration } from '@sentry/react';

// Make sure sentry is already initialized before this module is loaded
// We only capture replays on errors, but load this async so it doesn't block loading of the rest of the site
(function () {
  addIntegration(
    replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [window.location.origin, /^https:\/\//],
    }),
  );
})();
